import { render, staticRenderFns } from "./AegTransactionStakeholders.vue?vue&type=template&id=0ef563da"
import script from "./AegTransactionStakeholders.vue?vue&type=script&lang=js"
export * from "./AegTransactionStakeholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports